import { IJsonQuery, EDealType, EOfferType } from '../utils/jsonQuery';
import { EQueryParameters_2, ISuggestRequest } from '../repositories/geo-suggest/v2/suggest';
import { GeoSuggestDependencies, getGeoSuggestions, IGeoSuggestResult } from '../services/geoSuggest';
import { dealTypeFromJsonQuery, offerTypeFromJsonQuery } from '../utils/category';

export interface IGetGeoSuggestionsParameters {
  jsonQuery: IJsonQuery;
  regionId: number;
  query: string;
}

export function getGeoSuggestionItems(
  depenpencies: GeoSuggestDependencies,
  parameters: IGetGeoSuggestionsParameters,
): Promise<IGeoSuggestResult> {
  const formattedParameters = getFormattedGeoSuggestionsParameters(parameters);

  return getGeoSuggestions(depenpencies, formattedParameters);
}

export function getFormattedGeoSuggestionsParameters(parameters: IGetGeoSuggestionsParameters): ISuggestRequest {
  const { jsonQuery, regionId, query } = parameters;
  const dealType = dealTypeFromJsonQuery(jsonQuery);
  const offerType = offerTypeFromJsonQuery(jsonQuery);

  const queryDealType = mapDealType(dealType) as ISuggestRequest['dealType'];
  const queryOfferType = mapOfferType(offerType) as ISuggestRequest['offerType'];

  const isCoworkingSearch = !!jsonQuery?.coworking_offer_type?.value?.length;

  return {
    query,
    regionId,
    isCoworkingSearch,
    dealType: queryDealType,
    offerType: queryOfferType,
    source: EQueryParameters_2.Mainpage,
  };
}

export function mapDealType(dealType: EDealType): string | null {
  switch (true) {
    case (dealType & EDealType.Sale) !== 0:
      return 'sale';

    case (dealType & EDealType.Rent) !== 0:
      return 'rent';
  }

  return null;
}

export function mapOfferType(offerType: EOfferType): string | null {
  switch (true) {
    case offerType === EOfferType.FlatNew:
      return 'newobject';

    case (offerType & EOfferType.Flat) !== 0:
      return 'flat';

    case (offerType & EOfferType.Suburban) !== 0:
      return 'suburban';

    case (offerType & EOfferType.Commercial) !== 0:
      return 'commercial';
  }

  return null;
}
